import React from 'react';

function IconSelect({
  width = '1rem',
  style,
  viewBox = '0 0 8 14',
  className,
  fill = 'currentColor',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.707 4.122A.999.999 0 11.293 2.708L2.414.586a2 2 0 012.828 0l2.121 2.122A.999.999 0 115.95 4.122L3.83 2 1.706 4.12zM5.95 9.293a.999.999 0 111.413 1.414l-2.12 2.122a2 2 0 01-2.829 0l-2.12-2.122a.999.999 0 111.413-1.414l2.121 2.121 2.121-2.12z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}
export default IconSelect;
